
//let domianURL = "http://127.0.0.1:19001/api"//uni.getStorageSync('domianURL')//
//let domianURL = "https://bx1989.cn/api"//uni.getStorageSync('domianURL')//
let domianURL = "https://rest.ggxun.cn/api"
uni.setStorageSync("domianURL",domianURL);
export default {
	domianURL:() => {
        return uni.getStorageSync('domianURL')
      },

	url: uni.getStorageSync('domianURL'),
	request (url,data,method,contentType,showLoading=true) {
		console.log("请求网络"+this.domianURL() + url)
		if(!data){
			data = {pageSize:100}
		}
		if(!data.pageSize){
			data.pageSize = 300
		}
	    return new Promise((resolve, reject) => {
			if(showLoading){
				uni.showLoading({
				    title: '请求中...',
				    mask: true
				});
			}

			let header = {
	                'X-Access-Token': uni.getStorageSync('token') //自定义请求头信息
	            }
			if(contentType){
				header['content-type'] = contentType
			}
	        uni.request({
	            url: this.domianURL() + url, //仅为示例，并非真实接口地址。
	            data: data,
	            method: method,
	            header: header,
	            success: (res) => {
	                if(res.statusCode==401){
	                    uni.removeStorageSync("token")
	                    uni.reLaunch({
	                        url: '/pages/login/login',
	                    });
	                }else if(res.data.code==500){
						 uni.showToast({ title: res.data.message, icon: 'none' });
					}
	                resolve(res.data)
	            },
	            fail:(res) => {
					console.log(res)
					if(res.statusCode==500){
						 uni.showToast({ title: res.data.message, icon: 'none' });
					}else{
						 uni.showToast({ title: "网络连接失败", icon: 'none' });
					}
	                reject(res)
	            },
	            complete: (res) => {
	                uni.hideLoading()
	            },
	        });
	    });

	},
	get (url,data,showLoading) {
		 return this.request(url,data,"get",null,showLoading)
	},
	post (url,data,showLoading) {
		 return this.request(url,data,"post",null,showLoading)
	},
	postForm (url,data,showLoading) {
		 return this.request(url,data,"post","application/x-www-form-urlencoded",showLoading)
	},
	put (url,data,showLoading) {
		 return this.request(url,data,"put",null,showLoading)
	},
	delete (url,data,showLoading) {
		return this.request(url,data,"delete",null,showLoading)
   },
	uploadFile(files,progressUpdate){
		return new Promise((resolve, reject) => {
			let names = []
			let i = 0
			files.forEach((item)=>{
				if(names.indexOf(item.name)>=0){
					item.name=item.name+i
				}
				names.push(item.name)
				//item.name = 'file',
				item.uri =item.url
				i++
			})
			let parameter = {
				url: this.domianURL()+'/sys/common/upload', //仅为示例，非真实的接口地址
				//name: 'file',
				files:files,
				formData: {
					'biz': 'servicePic',
					'fileNames': names,
				},
				header: {
					'X-Access-Token': uni.getStorageSync('token') //自定义请求头信息
				},
				success: (res) => {
					if(res.data){
						let result = JSON.parse(res.data)
						resolve(result)
					}
				},
	            complete: (res) => {
	                uni.hideLoading()

	            },
				fail:(res) =>{
					console.log(res)
				}
			}
			uni.showLoading({
			    title: '上传中...',
			    mask: true
			});
			//console.log(parameter)
			const uploadTask = uni.uploadFile(parameter);
			uploadTask.onProgressUpdate((res) => {
				if(progressUpdate){
					progressUpdate(res)
				}
				console.log('上传进度' + res.progress);
				console.log('已经上传的数据长度' + res.totalBytesSent);
				console.log('预期需要上传的数据总长度' + res.totalBytesExpectedToSend);
				// if(res.progress!=100){
				// 	uni.showLoading({
				// 		title: '上传中：'+res.progress+"%",
				// 		mask: true
				// 	});
				// }else{
				// 	uni.hideLoading()
				// }
			});

		});

	}
}
